<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18ZM13.316 11.0695C11.5307 11.9621 10.75 12.8729 10.75 15H13.25C13.25 14.0021 13.4068 13.8192 14.434 13.3055C16.2193 12.4129 17 11.5021 17 9.375C17 6.65079 14.8554 5 12 5C9.23858 5 7 7.23858 7 10H9.5C9.5 8.61929 10.6193 7.5 12 7.5C13.5965 7.5 14.5 8.19551 14.5 9.375C14.5 10.3729 14.3432 10.5558 13.316 11.0695Z"
  />
</template>
